import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onUsersDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onUsersDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="user"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onUsersDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
